import Thumb from 'assets/icons/ReportThumbs/all_reports.png';

export default [
  {
    key: 'merchantMembershipsMetrics',
    text: 'Memberships Metrics',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: [`Sam's Club`, 'Costco', `BJ's Wholesale Club`],
    },
  },
  {
    key: 'aggregateMerchantMembershipsMetrics',
    text: 'Memberships Metrics',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: ['Walmart.com', 'Walmart Grocery'],
    },
  },
  {
    key: 'merchantRevenueMetrics',
    text: 'Membership Marketing',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: [`Sam's Club`],
    },
  },
  {
    key: 'merchantRevenueMetrics',
    text: 'Cashback Offer Metrics',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: ['Costco', 'Walmart.com'],
    },
  },
  {
    key: 'costcoMembershipExperimentMetrics',
    text: 'Costco Membership Experiment Metrics',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: ['Costco'],
    },
  },
  {
    key: 'attMetricsBySegment',
    text: 'AT&T Metrics By Segment',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: ['AT&T'],
    },
  },
  {
    key: 'lyftMetricsBySegment',
    text: 'Lyft Metrics By Segment',
    image: Thumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Custom',
      border: true,
      batchNotAllowed: true,
      merchantList: ['Lyft'],
    },
  },
];
